import { ConfigProvider } from 'antd';
import React, { useState } from 'react';
import '../../../../i18next';
import st from './styles.module.scss';
import Logo from './Logo';
import SelectLanguage from './SelectLanguage';
import AuthButtons from './AuthButtons';
import Sheet from './Sheet';
import { useLocation } from 'react-router';

const TopHeader = () => {
  const [open, setOpen] = useState(false);
  const showDrawer = () => setOpen(true);
  const closeDrawer = () => setOpen(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/' || location.pathname === '/employers';
  return (
    <ConfigProvider
      theme={{
        components: {
          Select: {
            colorBorder: 'transparent',
            colorBgContainer: 'transparent',
          },
        },
      }}
    >
      <div className={isHomePage ? st.topHeaderContainer : st.topHeaderRelative}>
        <div className={`container ${st.topHeader}`}>
          <Logo />
          <nav className="navbar navbar-expand-lg bg-body-tertiary">
            <div>
              <div className={st.headerButtonsWrapper}>
                <div className={st.headerButtons}>
                  <AuthButtons />
                </div>
                <SelectLanguage />
              </div>
            </div>
          </nav>
        </div>
        <Sheet onOpen={open} onClose={closeDrawer} />
      </div>
    </ConfigProvider>
  );
};

export default TopHeader;
